if (!customElements.get('personalisation-form')) {
  customElements.define(
    'personalisation-form',
    class PersonalisationForm extends HTMLElement {
      constructor() {
        super();

        this.firstInput = this.querySelector('[id*="PersonalisationFirstLine-"]');
        this.secondInput = this.querySelector('[id*="PersonalisationSecondLine-"]');
        this.firstTextLine = this.querySelector('[data-bind="firstInputValue"]');
        this.secondTextLine = this.querySelector('[data-bind="secondInputValue"]');
        this.disclaimerCheckbox = this.querySelector('[id*="PersonalisationDisclaimer-"]');
        this.submitButton = this.querySelector('[type="submit"], button[name="personalisation-update"]');
        this.hrLine = this.querySelector('hr');

        this.updateSubmitButtonState(); 

        this.addEventListener('keyup', this.onKeyUpHandler.bind(this));
        this.disclaimerCheckbox.addEventListener('change', this.onCheckboxChangeHandler.bind(this));
      }

      updateSubmitButtonState() {
        // Disable submitButton if both input fields are empty or disclaimerCheckbox is unchecked
        this.submitButton.disabled = (this.firstInput.value.trim() === '' && this.secondInput.value.trim() === '') || this.disclaimerCheckbox.checked === false;
    }    

      onKeyUpHandler(event) {
        if (event.target.isEqualNode(this.firstInput)) {
          this.firstTextLine.innerHTML = event.target.value === "" ? "" : event.target.value.includes('&') ? event.target.value.split('&').join('<span>&</span>') : event.target.value;
          if (this.secondInput.value === "") {
            console.log("[2] input is empty");
            this.firstTextLine.style.display = 'block';
            this.secondTextLine.style.display = 'none';
            this.hrLine.style.display = 'none';
          } else {
            this.secondTextLine.style.display = 'block';
            this.firstTextLine.style.display = 'block';
            this.hrLine.style.display = 'block';
          }
        } else if (event.target.isEqualNode(this.secondInput)) {
          this.secondTextLine.innerHTML = event.target.value === "" ? "" : event.target.value.includes('&') ? event.target.value.split('&').join('<span>&</span>') : event.target.value;
          if (this.firstInput.value === "") {
            console.log("[1] input is empty");
            this.secondTextLine.style.display = 'block';
            this.firstTextLine.style.display = 'none';
            this.hrLine.style.display = 'none';
          } else {
            this.secondTextLine.style.display = 'block';
            this.firstTextLine.style.display = 'block';
            this.hrLine.style.display = 'block';
          }
        }
        this.updateSubmitButtonState(); 
      }

      onCheckboxChangeHandler(event) {
        this.updateSubmitButtonState(); 
      }
    }
  );
}
